export const openWebsiteAction = async (url: string) => {
    window.open(url, '_blank');
};
